<template>
    <Link :href="'/'">
    <jet-application-logo class="w-64 bg-gray-900 pt-6 pb-6 rounded mx-auto" />
    </Link>
</template>
<script>
import JetApplicationLogo from '@/Jetstream/ApplicationLogo.vue';
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        JetApplicationLogo,
        Link,
    },
}

</script>
